module.exports = __webpack_public_path__ + "static/img/icon-tel.ebec096f.png";